var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pros-list"},_vm._l((_vm.pros),function(pro,proIndex){return _c('li',{key:proIndex},[_c('i',{staticClass:"fa-solid fa-check-circle icon"}),_vm._v(" "),_c('div',{staticClass:"pro rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(pro))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }